module.exports = require('./helpers/bundle-url').getBundleURL('fVM3f') + "logo.c51670a8.svg";